/**
 * Canonical marketing header navigation.
 * Import this everywhere instead of inlining a NAV array in every page.
 *
 * Order is intentional and mandated by product: About → Product → Features →
 * How it works → Workflow → Resources.
 */
export const MARKETING_NAV = [
  { label: "About",        href: "/about" },
  { label: "Product",      href: "/product" },
  { label: "Features",     href: "/features" },
  { label: "How it works", href: "/how-it-works" },
  { label: "Workflow",     href: "/workflow" },
  { label: "Resources",    href: "/resources" },
];
